module.exports = __webpack_public_path__ + "img/512467685.6b0e4a90.jpg";